import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch } from "react-redux";
import { handleRemarkLead, throwError, throwSuccess } from "store/slices";
import { objectToFormData } from "utils/helpers";

const LeadStatus = ({
  abstract_id,
  lead: parentLead = "-",
  onSuccess,
  isTitle = false,
}) => {
  const [lead, setLead] = useState(parentLead);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setLead(parentLead || "-");
  }, [parentLead]);
  
  const leadStyle = (value) => {
    const base = {
      borderRadius: "6px",
      padding: "0 10px",
      height: "26px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "13px",
      fontWeight: 500,
      border: "1px solid transparent",
      lineHeight: "1",
    };

    switch (value) {
      case "Hot":
        return {
          ...base,
          border: "1px solid #e34646",
          color: "#e34646",
          backgroundColor: "#fddcdc",
        };
      case "Warm":
        return {
          ...base,
          border: "1px solid #e8a700",
          color: "#e8a700",
          backgroundColor: "#fff4cc",
        };
      case "Cold":
        return {
          ...base,
          border: "1px solid #597cea",
          color: "#597cea",
          backgroundColor: "#dce3ff",
        };
      default:
        return {
          ...base,
          border: "1px solid #ccc",
          color: "#666",
          backgroundColor: "#f8f8f8",
        };
    }
  };

  // ✅ Save immediately when user selects a new lead
  const handleSelect = async (status) => {
    if (lead === status) return; // avoid duplicate API call
    setLead(status);
    setIsLoading(true);

    const response = await dispatch(
      handleRemarkLead(objectToFormData({ abstract_id, lead: status }))
    );

    if (response?.status === 200) {
      dispatch(throwSuccess(response?.message));
      onSuccess?.(status);
    } else {
      dispatch(throwError({ message: response?.message }));
    }

    setIsLoading(false);
  };

  return (
    <div className="d-flex align-items-center gap-2">
      {isTitle && <span className="text-14-500-18">Status:</span>}

      <Dropdown align="start">
        <Dropdown.Toggle
          id="dropdown-basic"
          variant="light"
          style={{
            ...leadStyle(lead),
            boxShadow: "none",
            outline: "none",
          }}
          disabled={isLoading}
        >
          {lead && lead !== "" && lead !== null ? lead : "-"}
        </Dropdown.Toggle>

        <Dropdown.Menu
          style={{
            borderRadius: "8px",
            minWidth: "100px",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.08)",
            marginTop: "5px",
            padding: "5px 0",
          }}
        >
          {["Hot", "Cold", "Warm"].map((status) => (
            <Dropdown.Item
              key={status}
              onClick={() => handleSelect(status)}
              style={{
                fontSize: "13px",
                padding: "6px 14px",
                color: lead === status ? leadStyle(status).color : "#000",
                backgroundColor:
                  lead === status ? "rgba(0,0,0,0.04)" : "transparent",
              }}
            >
              {status}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default LeadStatus;
